import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Table from "@/components/common/table";
import { Tractor_listing } from "../../../../tables-columns/Tractor-listing";
import DeleteModal from "components/common/confirm-delete-modal.component";
import AddMachinery from "./AddMachinery/AddMachinery";
import ActionButtons from "./ActionButtons/ActionButtons";
import { authServices } from "services/auth.services";
import Cookie from "js-cookie";
import axios from "axios";
import EditModal from "./AddMachinery/editMachinaryModal";
import Loader from "@/components/common/loader.components";
import PageTitle from "@/components/common/page-title.component";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
type RowData = {
  id?: any;
};
export default function Machinary() {
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowData, setRowData] = useState<RowData>({});
  const [dataRow, setDataRow] = useState<any>([]);
  const router = useRouter();
  const [showEditModal, setShowEditModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setpage] = useState(1);
  const SubCategorie = router.query;
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    const getLink = () => {
      if (SubCategorie.innerPage === "horsch-tiger") {
        return `/assets/machinery/?org_id__id=${authServices.userValue.org_id}&machinery_category=horsch_tiger&page=${page}`;
      } else {
        return `/assets/machinery/?org_id__id=${authServices.userValue.org_id}&machinery_category=${SubCategorie.innerPage}&page=${page}`;
      }
    };
    axios
      .get(
        getLink(),

        {
          headers: {
            Authorization: `Bearer ${Cookie.get("token")}`,
          },
        }
      )
      .then((response) => {
        const data = response.data;
        setDataRow(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [SubCategorie, page]);
  useEffect(() => {
    const getLink = () => {
      if (SubCategorie.innerPage === "horsch-tiger") {
        return `/assets/machinery/?org_id__id=${authServices.userValue.org_id}&machinery_category=horsch_tiger&page=${page}`;
      } else {
        return `/assets/machinery/?org_id__id=${authServices.userValue.org_id}&machinery_category=${SubCategorie.innerPage}&page=${page}`;
      }
    };
    axios
      .get(
        getLink(),

        {
          headers: {
            Authorization: `Bearer ${Cookie.get("token")}`,
          },
        }
      )
      .then((response) => {
        const data = response.data;
        setDataRow(data);
        setRefresh(0);
      })
      .catch((error) => {
        console.log(error.response);
      });
  }, [refresh === 1]);
  const DeleteRow = async (rowId) => {
    await axios
      .delete(`assets/machinery/${rowId}/`, {
        headers: { Authorization: `Bearer ${Cookie.get("token")}` },
      })
      .then((response) => {
        setShowDeleteModal(!showDeleteModal);
        if (response.status === 204) {
          axios
            .get(
              `/assets/machinery/?org_id__id=${authServices.userValue.org_id}&machinery_category=${SubCategorie.innerPage}&page=${page}`,
              {
                headers: { Authorization: `Bearer ${Cookie.get("token")}` },
              }
            )
            .then((response) => {
              let data = response.data;
              setDataRow(data);
            });
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
  const tableActions = [
    {
      title: "view",
      action(row: any) {},
    },
    {
      title: "edit",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("edit")
          ? (setShowEditModal(!showEditModal), setRowData(row.original))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },

    {
      title: "delete",
      action(row: any) {
        authServices.userValue.policy_data.asset.actions.includes?.("delete")
          ? (setRowData(row.original), setShowDeleteModal(!showDeleteModal))
          : dispatch(
              setNotAuthorizedAlertData({ key: "showModal", value: true })
            );
      },
    },
  ];

  const getEntityTypeId = () => {
    if (router.query.innerPage === "tractor") {
      return 15;
    } else if (router.query.innerPage === "plower") {
      return 16;
    } else if (router.query.innerPage === "disk") {
      return 17;
    } else if (router.query.innerPage === "marker") {
      return 18;
    } else if (router.query.innerPage === "rotavator") {
      return 19;
    } else if (router.query.innerPage === "planter") {
      return 20;
    } else if (router.query.innerPage === "spreader") {
      return 21;
    } else if (router.query.innerPage === "sprayer") {
      return 22;
    } else if (router.query.innerPage === "opener") {
      return 23;
    } else if (router.query.innerPage === "digger") {
      return 24;
    } else if (router.query.innerPage === "harvester") {
      return 25;
    } else if (router.query.innerPage === "horsch-tiger") {
      return 27;
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <div className="w-full">
          <PageTitle
            title={[t("Assets"), t(`${SubCategorie.innerPage}`)]}
            hasLink={true}
            link="/assets"
          />
        </div>
        <ActionButtons
          showModal={showModal}
          setShowModal={setShowModal}
          label={t(`${SubCategorie.innerPage}`)}
        />
      </div>

      <Table
        fillPage={true}
        columns={Tractor_listing(t, i18n)}
        data={dataRow.results ?? []}
        manualPageination={true}
        totalPages={dataRow.total_pages}
        goToPage={(currentPage) => setpage(currentPage)}
        tableAction={tableActions}
        crntpage={page}
      />
      <DeleteModal
        id={rowData?.id ?? null}
        setShowModel={setShowDeleteModal}
        showModel={showDeleteModal}
        deleteTrigger={DeleteRow}
        /* mutate={mutate} */
      />

      <AddMachinery
        setRefresh={setRefresh}
        showModal={showModal}
        setShowModal={setShowModal}
        defaultValue={router.query.innerPage}
        getEntityTypeId={getEntityTypeId()}
      />
      <EditModal
        setRefresh={setRefresh}
        setRowData={setRowData}
        rowData={rowData}
        showModal={showEditModal}
        setShowModal={setShowEditModal}
        defaultValue={router.query.innerPage}
        getEntityTypeId={getEntityTypeId()}
      />
    </div>
  );
}
